<template lang="html">
  <v-card class="mt-1">
    <change-log-event-group           :event="event"
                                      :show-time="showTime"
                                      :participants="participants" v-if="isChangeLogEventGroup"/>
    <user-checkin-event               :event="event"
                                      :events="events"
                                      :show-time="showTime"
                                      :load="load"
                                      :participants="participants" v-else-if="isUserCheckinEvent"/>
    <user-comment-event               :event="event"
                                      :show-time="showTime"
                                      :participants="participants" v-else-if="isUserCommentEvent"/>
    <driver-accepted-load-event       :event="event"
                                      :show-time="showTime"
                                      :participants="participants" v-else-if="isDriverAcceptedLoadEvent"/>
    <driver-assignment-event          :event="event"
                                      :show-time="showTime"
                                      :participants="participants" v-else-if="isDriverAssignmentEvent"/>
    <user-media-upload-event          :event="event"
                                      :show-time="showTime"
                                      :participants="participants" v-else-if="isUserMediaEvent"/>
    <document-processing-event        :event="event"
                                      :show-time="showTime"
                                      :participants="participants"
                                      v-else-if="isDocumentProcessingEvent"/>
    <loading-chute-instructions-event :event="event"
                                      :show-time="showTime"
                                      :participants="participants"
                                      v-else-if="isLoadingChuteInstructionsEvent"/>
    <upload-progress-event            :event="event"
                                      v-else-if="isUploadingFileEvent"/>
    <v-layout v-else>
      Unsupported Event: {{event.event}}. Call {{ $t('site-title') }} to fix this.
    </v-layout>
  </v-card>
</template>

<script>

import _ from 'lodash';
import { timelineEvent } from '@/types';
import ChangeLogEventGroup from '@/components/timeline/ChangeLogEventGroup';
import UserCheckinEvent from '@/components/timeline/UserCheckinEvent';
import UserCommentEvent from '@/components/timeline/UserCommentEvent';
import DriverAcceptedLoadEvent from '@/components/timeline/DriverAcceptedLoadEvent';
import DriverAssignmentEvent from '@/components/timeline/DriverAssignmentEvent';
import UserMediaUploadEvent from '@/components/timeline/UserMediaUploadEvent';
import UploadProgressEvent from '@/components/timeline/UploadProgressEvent';
import DocumentProcessingEvent from '@/components/timeline/DocumentProcessingEvent';
import LoadingChuteInstructionsEvent from '@/components/timeline/LoadingChuteInstructionsEvent';

export default {
  name: 'EventLine',
  components: {
    LoadingChuteInstructionsEvent,
    ChangeLogEventGroup,
    DocumentProcessingEvent,
    DriverAssignmentEvent,
    DriverAcceptedLoadEvent,
    UserCheckinEvent,
    UserCommentEvent,
    UserMediaUploadEvent,
    UploadProgressEvent,
  },
  props: {
    events: {
      type: Array,
      required: false,
    },
    event: {
      required: true,
      type: Object,
    },
    participants: {
      required: true,
      type: Array,
    },
    load: {
      type: Object,
      required: false,
    },
    showTime: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    isChangeLogEvent() {
      // we shouldn't be seeing any of these -
      // they have been transformed to change event groups
      return timelineEvent.CHANGE_LOG === this.event.event;
    },
    isChangeLogEventGroup() {
      return timelineEvent.TIMESTAMP_CHANGE_LOG_GROUP === this.event.event;
    },
    isLoadingChuteInstructionsEvent() {
      return timelineEvent.LOADING_CHUTE_INSTRUCTIONS === this.event.event;
    },
    isUserCommentEvent() {
      const isUserMessage = timelineEvent.USER_MESSAGE === this.event.event;
      const isMediaMessage = _.get(this.event, 'mediaMessage', false);
      return isUserMessage && !isMediaMessage;
    },
    isUserCheckinEvent() {
      return timelineEvent.USER_CHECKIN === this.event.event;
    },
    isDriverAcceptedLoadEvent() {
      return timelineEvent.DRIVER_ACCEPT_ASSIGNMENT === this.event.event;
    },
    isDriverAssignmentEvent() {
console.log('COMPONENT EventLine isDriverAssignmentEvent ' + this.event.event);
      return timelineEvent.DRIVER_ASSIGNMENT === this.event.event;
    },
    isUserMediaEvent() {
      const isUserMessage = timelineEvent.USER_MESSAGE === this.event.event;
      const isMediaMessage = _.get(this.event, 'mediaMessage', false);
      return isUserMessage && isMediaMessage;
    },
    isDocumentProcessingEvent() {
      return timelineEvent.DOCUMENT_PROCESSING === this.event.event;
    },
    isUploadingFileEvent() {
      return timelineEvent.UPLOADING_FILE === this.event.event;
    },
  },
};
</script>

<style lang="css">
 .event-line {
   /* max-height:60px; */
   /* height: 40px; */
 }
</style>



// WEBPACK FOOTER //
// src/components/EventLine.vue